<template>
  <v-row>
    <v-col
      cols="12"
      sm="12"
      md="12"
      lg="6"
      :class="[{'even pr-16': index % 2 === 0}, {'odd justify-start ': index % 2 !== 0}, 'article d-flex my-8']"
      v-for="(article, index) in articles"
      :key="article.id">
      <div class="wrapper">
        <a :aria-label="article[`${$language.current}Title`]" rel="noopener" class="mr-16 heading generic-image-link" v-if="article.external_url" :href="article.external_url" target="_blank">
          <seo-v-img
            v-if="article.thumbnail"
            class="thumbnail"
            cover
            :width="$vuetify.breakpoint.smAndDown ? '92vw' : 380"
            :aspect-ratio="0.8"
            :src="`/media/${article.thumbnail.id}`"
            :lazy-src="lazyImgSrc(article.thumbnail)"
          />
          <h2 class="pl-sm-4 mt-4 mt-sm-4 mb-4" v-html="hypenate(article[`${$language.current}Title`])"></h2>
          <span class="pl-sm-4 ">{{article[`${$language.current}Nationality`]}}</span>
        </a>
        <router-link :aria-label="article[`${$language.current}Title`]" v-else class="generic-image-link" :to="{name: 'InitiativesArticle', params: {projectSlug: projectSlug, slug: article._slug, articleList: articles }}">
          <seo-v-img
            v-if="article.thumbnail"
            class="thumbnail"
            cover
            :width="$vuetify.breakpoint.smAndDown ? '92vw' : 380"
            :aspect-ratio="0.8"
            :src="`/media/${article.thumbnail.id}`"
            :lazy-src="lazyImgSrc(article.thumbnail)"
          />
          <h2 class="pl-sm-4 mt-4 mt-sm-4 mb-4" v-html="hypenate(article[`${$language.current}Title`])"></h2>
          <span class="pl-sm-4 ">{{article[`${$language.current}Nationality`]}}</span>
        </router-link>
      </div>
    </v-col>
  </v-row>

</template>

<script>
import { RAF, ElasticNumber } from '@monogrid/js-utils'
import { Viewport } from '@monogrid/vue-lib'

export default {
  name: 'ContentArticleList',
  mixins: [Viewport],
  props: {
    articles: {
      type: Array,
      required: true
    },
    projectSlug: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      selectedArticle: null,
      elasticMouseX: new ElasticNumber(0),
      elasticMouseY: new ElasticNumber(0)
    }
  },

  computed: {
    currentThumbnail () {
      return this.selectedArticle && this.selectedArticle.thumbnail.id
    },
    thumbnailStyle () {
      return {
        transform: `translate3d(${this.elasticMouseX.value}px, ${this.elasticMouseY.value}px, 0)`
      }
    }
  },

  mounted () {
    this.time = new Date().getTime()
    RAF.add(this.update)
  },

  methods: {
    update () {
      const now = new Date().getTime()
      const delta = (now - this.time) / 1000
      this.elasticMouseX.update(Math.min(delta, 1 / 10))
      this.elasticMouseY.update(Math.min(delta, 1 / 10))
    },
    handleMouseMove (e) {
      this.elasticMouseX.target = e.pageX
      this.elasticMouseY.target = e.pageY
    },
    handleMouseEnter (e, article) {
      // console.log('enter')
      this.selectedArticle = article
    },
    handleMouseLeave (e) {
      this.selectedArticle = null
    },
    handleDesignerClick (slug, article) {
      this.$router.push({ name: 'Designer', params: { slug: slug } })
    },
    lazyImgSrc (image) {
      const meta = JSON.parse(image.metaData)
      return meta['image-lazy-src']
    },
    hypenate (str) {
      return str.replace(/\u200B/g, '&shy;')
    }
  }
}
</script>

<style scoped lang="scss">
  .absolute {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 10;
    pointer-events: none;
  }

  .article {
    &:nth-child(even) {
      padding-top: 100px;
      @include breakpoint('xs-only') {
        padding-top: 0;
      }
    }
  }

  .wrapper {
    max-width: 540px;

    .heading {
      font-family: $heading-font-family;
      font-size: 3.5vh;
      position: relative;
      z-index: 20;
    }

    h2 {
      hyphens: auto;
      font-family: $heading-font-family;
      font-size: 3.2rem;
      text-transform: uppercase;
      @include breakpoint('lg-and-down') {
        font-size: 2.5rem;
      }

      @include breakpoint('sm-and-down') {
        font-size: 2rem;
      }
    }

    .nationality {
      font-size: 1.8vh;
    }
  }

  .thumbnail-enter-active,
  .thumbnail-leave-active {
    transition: opacity 1s $ease-in-out-quart;

  }

  .thumbnail-enter {
    opacity: 0;
  }

  .thumbnail-leave-to {
    opacity: 0;
  }
</style>
